export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7934.f2386cc8.jpg";